__turbopack_context__.v({
  "chip": "nD6Vzq_chip",
  "item": "nD6Vzq_item",
  "link": "nD6Vzq_link",
  "linkActive": "nD6Vzq_linkActive",
  "links": "nD6Vzq_links",
  "list": "nD6Vzq_list",
});
